export enum DocumentsTarget {

    Retail = 0,
    Professional = 1,
    All = 2
}
